import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MoonStarsSvg = function MoonStarsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.763 6.043V4.761h-1.282V3.283h1.282V2h1.479v1.283h1.282V4.76h-1.282v1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.837 4.564-.582 1.102a5.239 5.239 0 0 0 7.079 7.08l1.101-.582-.017 1.245a8.71 8.71 0 1 1-8.827-8.828zm-2.38 1.604a7.231 7.231 0 1 0 8.374 8.375 6.717 6.717 0 0 1-8.374-8.375",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.24 9.469v1.282h1.478V9.469H22V7.99h-1.282V6.707h-1.479V7.99h-1.282V9.47z"
  }));
};
export var MoonStars = function MoonStars(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MoonStarsSvg
  }));
};